if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
      });

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });

      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {

        window.addEventListener('scroll', this.setAnnouncementHeight.bind(this), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Mobile Navigation transparent header support.
      setTimeout(() => {

        this.mobile_nav = document.querySelector('.header-mobile-navigation');

        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);
      // Buttons.
      this.bindMenu();
      this.setupLazyMenu();
    }
    bindMenu() {
      this.setupScrollHints();
      this.menu.querySelectorAll('summary:not([data-s4t-bound])').forEach(summary => {
        summary.setAttribute('data-s4t-bound', '');
        summary.addEventListener('click', this.onSummaryClick.bind(this));
      });
      this.menu.querySelectorAll('.parent-link-back--button:not([data-s4t-bound])').forEach(button => {
        button.setAttribute('data-s4t-bound', '');
        button.addEventListener('click', this.onCloseButtonClick.bind(this));
      });
    }
    /*
     * Scroll-Hinweise im Handymenue (CSS in assets/s4t-mm-quick.css):
     * Balken unter der wischbaren Kategorien-Reihe und Klasse s4t-mm-more am
     * Menue, solange unten noch Inhalt kommt (Verlauf + Pfeil ueber dem Fuss).
     */
    setupScrollHints() {
      const menu = this.menu;
      if (!menu) return;
      menu.querySelectorAll('.mm-cats:not([data-s4t-bar])').forEach(list => {
        list.setAttribute('data-s4t-bar', '');
        const bar = document.createElement('div');
        bar.className = 'mm-scrollbar';
        bar.setAttribute('aria-hidden', 'true');
        const thumb = document.createElement('span');
        bar.appendChild(thumb);
        list.after(bar);
        const update = () => {
          const sw = list.scrollWidth, cw = list.clientWidth;
          if (!cw || sw <= cw + 2) { bar.hidden = true; return; }
          bar.hidden = false;
          const size = cw / sw;
          thumb.style.width = (size * 100) + '%';
          thumb.style.left = (list.scrollLeft / (sw - cw) * (1 - size) * 100) + '%';
        };
        list.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        menu._s4tBars = (menu._s4tBars || []).concat(update);
        update();
      });
      const more = () => {
        const left = menu.scrollHeight - menu.clientHeight - menu.scrollTop;
        menu.classList.toggle('s4t-mm-more', left > 12);
        (menu._s4tBars || []).forEach(fn => fn());
      };
      if (!menu._s4tMoreBound) {
        menu._s4tMoreBound = true;
        menu.addEventListener('scroll', more, { passive: true });
        window.addEventListener('resize', more);
        menu.addEventListener('toggle', () => setTimeout(more, 60), true);
        menu.addEventListener('transitionend', more);
        this.toggle && this.toggle.addEventListener('click', () => setTimeout(more, 80));
        if ('ResizeObserver' in window) new ResizeObserver(more).observe(menu);
      }
      more();
    }
    /*
     * Handymenue nachladen (snippets/header-mobile-toggle): Der Header kommt
     * mit leerer Huelle; das volle Menue holt die Section-API
     * (/?view=s4t-mm&section_id=<Header>). Auf dem Handy im Leerlauf nach dem
     * Laden, sonst spaetestens beim Antippen. Pro Sitzung zwischengespeichert.
     */
    setupLazyMenu() {
      if (!this.menu || !this.menu.hasAttribute('data-s4t-mm-lazy')) return;
      const section = this.closest('.shopify-section');
      if (!section || !section.id) return;
      const sectionId = section.id.replace('shopify-section-', '');
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const url = root + '?view=s4t-mm&section_id=' + encodeURIComponent(sectionId);
      const cacheKey = 's4t-mm:' + root + ':' + sectionId;
      let pending = null;
      const apply = (html) => {
        if (!this.menu.hasAttribute('data-s4t-mm-lazy')) return true;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const full = doc.querySelector('#mobile-menu');
        if (!full || full.hasAttribute('data-s4t-mm-lazy')) return false;
        this.menu.innerHTML = full.innerHTML;
        this.menu.removeAttribute('data-s4t-mm-lazy');
        this.bindMenu();
        document.dispatchEvent(new CustomEvent('s4t:mobile-menu-loaded'));
        return true;
      };
      const load = () => {
        if (pending || !this.menu.hasAttribute('data-s4t-mm-lazy')) return pending;
        try {
          const cached = sessionStorage.getItem(cacheKey);
          if (cached && apply(cached)) return (pending = Promise.resolve());
        } catch (e) {}
        pending = fetch(url, { credentials: 'same-origin' })
          .then(r => (r.ok ? r.text() : Promise.reject(r.status)))
          .then(html => {
            if (!apply(html)) return Promise.reject('kein Menue');
            this.menu.removeAttribute('data-s4t-mm-failed');
            try { sessionStorage.setItem(cacheKey, html.slice(html.indexOf('<nav id="mobile-menu"'))); } catch (e) {}
          })
          .catch(() => {
            // Beim naechsten Antippen erneut versuchen; bis dahin die Ratgeber-Liste als Ersatz zeigen
            pending = null;
            this.menu.setAttribute('data-s4t-mm-failed', '');
          });
        return pending;
      };
      const summary = this.toggle.querySelector('.mobile-toggle');
      ['pointerdown', 'touchstart', 'focus'].forEach(ev => summary.addEventListener(ev, load, { passive: true }));
      summary.addEventListener('click', load);
      const idle = () => {
        if (summary.offsetParent === null) return; // Desktop: Menueknopf unsichtbar
        (window.requestIdleCallback || ((fn) => setTimeout(fn, 1500)))(load, { timeout: 4000 });
      };
      if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle, { once: true });
    }
    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        this.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');
      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');
    }
    connectedCallback() {
      this.setupMegaMenuProducts();
      this.setupInstantSwitch();
      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      document.fonts.ready.then(function() {
        window.addEventListener('resize', debounce(function() {
          _this.resizeSubMenus();
        }, 100));
      });

    }
    setupMegaMenuProducts() {
      const placeholders = this.querySelectorAll('.megamenu-products-placeholder[data-megamenu-collection]');
      const loaders = [];
      placeholders.forEach((placeholder) => {
        const item = placeholder.closest('.menu-item-has-megamenu');
        if (!item) {
          return;
        }
        let loaded = false;
        const load = () => {
          if (loaded) {
            return Promise.resolve();
          }
          loaded = true;
          const handle = placeholder.getAttribute('data-megamenu-collection');
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          return fetch(`${root}collections/${handle}?section_id=mega-menu-products`)
            .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
            .then((html) => {
              const fragment = new DOMParser().parseFromString(html, 'text/html');
              const columns = fragment.querySelectorAll('.megamenu-product-col');
              if (!columns.length) {
                return;
              }
              columns.forEach((column) => placeholder.parentNode.insertBefore(column, placeholder));
              placeholder.remove();
              // Das Mega-Menue ist beim Einfuegen oft noch unsichtbar
              // (Einblend-Animation) - lazySizes laedt versteckte Bilder nicht
              // (loadHidden: false), dadurch blieben Produktbilder weiss.
              // Deshalb die eingefuegten Bilder direkt laden.
              if (window.lazySizes && window.lazySizes.loader) {
                item.querySelectorAll('.megamenu-product-col img.lazyload').forEach((img) => {
                  window.lazySizes.loader.unveil(img);
                });
                window.lazySizes.loader.checkElems();
              }
            })
            .catch(() => {
              loaded = false;
            })
            .then(() => this.equalizeMegaMenus());
        };
        loaders.push(load);
        item.addEventListener('mouseenter', load);
        item.addEventListener('focusin', load);
        item.addEventListener('touchstart', load, { passive: true });
      });
      // Am Desktop die Produkte schon vorab laden, sobald die Seite ruht -
      // sonst klappte das Dropdown beim ersten Hover nach ~0,3 s ein zweites
      // Mal auf (Produkte kamen nach) und alle Dropdowns gleich hoch zu
      // machen ginge erst nach dem Hover.
      const desktop = window.matchMedia('(hover: hover) and (min-width: 1068px)');
      const preload = () => {
        if (!desktop.matches) return;
        const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1));
        idle(() => loaders.forEach((load) => load()), { timeout: 3000 });
      };
      if (document.readyState === 'complete') {
        setTimeout(preload, 1200);
      } else {
        window.addEventListener('load', () => setTimeout(preload, 1200), { once: true });
      }
      this.equalizeMegaMenus();
      window.addEventListener('load', () => this.equalizeMegaMenus(), { once: true });
      window.addEventListener('resize', debounce(() => this.equalizeMegaMenus(), 150));
      // Nachladende Produktbilder koennen die Hoehe noch aendern
      this.addEventListener('load', debounce(() => this.equalizeMegaMenus(), 150), true);
    }
    // Alle Mega-Menues gleich hoch (so hoch wie das hoechste) - beim
    // Wechsel zwischen den Menuepunkten sprang die Unterkante sonst auf und
    // ab. Gemessen wird ohne Mindesthoehe; die Dropdowns sind dabei nur
    // unsichtbar (visibility), also messbar.
    equalizeMegaMenus() {
      const containers = this.querySelectorAll('.thb-full-menu > li > .sub-menu.mega-menu-container');
      if (!containers.length || !window.matchMedia('(min-width: 1068px)').matches) {
        this.style.removeProperty('--s4t-mm-h');
        return;
      }
      this.style.setProperty('--s4t-mm-h', 'auto');
      let max = 0;
      containers.forEach((c) => {
        max = Math.max(max, c.offsetHeight);
      });
      if (max > 0) this.style.setProperty('--s4t-mm-h', `${max}px`);
    }
    // Beim Wechsel direkt von einem Dropdown zum naechsten ohne Animation
    // umschalten - sonst laufen Zu- und Aufklappen zweier unterschiedlich
    // hoher Menues und zweier Overlays gleichzeitig. Das erste Oeffnen bleibt
    // animiert.
    setupInstantSwitch() {
      if (this._s4tSwitch) return;
      this._s4tSwitch = true;
      let lastLeave = 0;
      let timer = null;
      this.querySelectorAll('.thb-full-menu > li.menu-item-has-children').forEach((item) => {
        item.addEventListener('mouseleave', () => {
          lastLeave = Date.now();
        });
        item.addEventListener('mouseenter', () => {
          if (Date.now() - lastLeave > 400) return;
          this.classList.add('s4t-menu-switch');
          clearTimeout(timer);
          timer = setTimeout(() => this.classList.remove('s4t-menu-switch'), 350);
        });
      });
    }
    resizeSubMenus() {
      const viewportWidth = window.innerWidth;
      const updates = [];

      // Read phase: gather all measurements first so we never read a layout
      // property right after writing one (which forces a synchronous reflow).
      this.submenus.forEach((submenu) => {
        const sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');
        sub_submenus.forEach((sub_submenu) => {
          const parent = sub_submenu.parentElement;
          const total = sub_submenu.offsetWidth + parent.getBoundingClientRect().left + parent.offsetWidth;
          updates.push({ parent: parent, overflow: total > viewportWidth });
        });
      });

      // Write phase: apply all class changes after every measurement is done.
      updates.forEach((update) => {
        update.parent.classList.toggle('left-submenu', update.overflow);
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.expand = 250;
window.lazySizesConfig.loadMode = 1;
window.lazySizesConfig.loadHidden = false;